<ns-dialog-content>
  <nes-heading tag="h1" size="3xl" class="nes-mb-2 upload-dialog-title">
    {{ "USER_DATA.FACE_IMAGE.TITLE" | translate }}
  </nes-heading>
  <nes-text class="nes-mb-5">
    {{ "USER_DATA.FACE_IMAGE.INFO" | translate }}
  </nes-text>

  <div *ngIf="isUploading; else uploadLayout" class="basicLoader"></div>

  <ng-template #uploadLayout>
    <div class="upload-layout" [class.has-image]="!!selectedImage">

      <!-- LEFT: placeholder / selected image — desktop only, hidden on mobile -->
      <div class="upload-media">
        <ng-container *ngIf="selectedImage; else mediaPlaceholder">
          <div class="image-preview" privacySensitive>
            <img [src]="selectedImage.imageAsBase64 | displayImage" alt="" />
          </div>
        </ng-container>
        <ng-template #mediaPlaceholder>
          <div class="image-placeholder">
            <div class="placeholder-icon-wrapper">
              <nes-icon name="user"></nes-icon>
            </div>
          </div>
        </ng-template>
      </div>

      <!-- RIGHT: checklist + errors + buttons -->
      <div class="upload-content">
        <nes-text-list list-type="checked" size="base" color="blue">
          <nes-text-list-item
            *ngFor="let item of 'USER_DATA.FACE_IMAGE.IMAGE_CHECKLIST' | translate"
          >
            <span>{{ item }}</span>
          </nes-text-list-item>
        </nes-text-list>

        <ng-container *ngIf="metrics">
          <div class="photo-rejection-error">
            <div class="photo-rejection-error__left-bar"></div>
            <div class="photo-rejection-error__content">
              <div class="photo-rejection-error__title">
                <nes-icon name="alert-thick-filled" class="photo-rejection-error__icon"></nes-icon>
                {{ 'USER_DATA.FACE_IMAGE.DECLINED' | translate }}
              </div>
              <ul class="photo-rejection-error__list">
                <li *ngFor="let metric of metrics">
                  {{ metric.metricMessage ? metric.metricMessage : ('USER_DATA.FACE_IMAGE.DEFAULT_METRIC' | translate) }}
                </li>
              </ul>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="hasFileSizeError">
          <p class="inlineNotification inlineNotification--alert">
            <i class="icon icon--alert icon--nsRed icon--inline inlineNotification__icon"></i>
            <span class="inlineNotification__text">
              {{ "USER_DATA.FACE_IMAGE.ERROR.FILE_SIZE" | translate }}
            </span>
          </p>
        </ng-container>
        <ng-container *ngIf="hasFileTypeError">
          <p class="inlineNotification inlineNotification--alert">
            <i class="icon icon--alert icon--nsRed icon--inline inlineNotification__icon"></i>
            <span class="inlineNotification__text">
              {{ "USER_DATA.FACE_IMAGE.ERROR.FILE_TYPE" | translate }}
            </span>
          </p>
        </ng-container>

        <!-- Replace button when image is selected -->
        <nes-button
          *ngIf="selectedImage"
          (nesOnClick)="fileInput.click(); chooseAnother.emit()"
          [cypress]="'dialog_choose_another'"
          variant="secondary"
          type="button"
          class="nes-mt-5 btn-choose-another"
        >
          <span class="btn-inner">
            <svg class="btn-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
            {{ "USER_DATA.BUTTON.MAKE_PHOTO_NEW" | translate }}
          </span>
        </nes-button>

        <!-- Selected image — mobile only (shown in left column on desktop) -->
        <div *ngIf="selectedImage" class="image-preview image-preview--mobile nes-mt-4" privacySensitive>
          <img [src]="selectedImage.imageAsBase64 | displayImage" alt="" />
        </div>

        <!-- Upload button when no image selected -->
        <nes-button
          *ngIf="!selectedImage"
          [loading]="isUploading"
          (nesOnClick)="fileInput.click()"
          [cypress]="'dialog_accept'"
          variant="primary"
          type="button"
          class="nes-mt-5 btn-upload-photo"
        >
          <span class="btn-inner">
            <svg class="btn-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
            {{ "USER_DATA.BUTTON.MAKE_PHOTO" | translate }}
          </span>
        </nes-button>
      </div>

    </div>

    <!-- Separator — full width, spans both columns -->
    <hr class="modal-divider" />

    <!-- Action row: Save + Cancel -->
    <div class="modal-actions" [class.has-image]="!!selectedImage">
      <!-- Save button — only when image is selected -->
      <nes-button
        *ngIf="selectedImage"
        (click)="save.emit()"
        [cypress]="'dialog_save'"
        variant="primary"
        type="button"
        class="btn-save"
      >
        {{ "USER_DATA.BUTTON.SAVE_PHOTO" | translate }}
      </nes-button>

      <!-- Annuleer -->
      <span
        class="cancel-link"
        [cypress]="'dialog_decline'"
        (click)="cancel.emit()"
      >
        {{ "BUTTON.CANCEL" | translate }}
      </span>
    </div>
  </ng-template>

  <input
    #fileInput
    class="s-hidden"
    [cypress]="'upload_image'"
    type="file"
    (change)="onFileSelected($event)"
    accept="image/*"
  />
</ns-dialog-content>

